import { hasFeatureFlag } from './featureFlags/hasFeatureFlag';
import { newInfiniteScrolling } from '../activeFeatureFlags';

export const getDefaultPageSize = (cookies: Record<string, string>) => {
  const hasNewInfiniteScrolling = hasFeatureFlag(newInfiniteScrolling, cookies);

  // actual visible card count is 36 and 74 when including the search buddy teaser cards
  return hasNewInfiniteScrolling ? 35 : 72;
};
